// bookings/components/tabs/accessories/AccessoriesDrawer.jsx
import React from "react";
import { Offcanvas, Row, Col, Button } from "react-bootstrap";
import useAccessoriesEditor from "../../../hooks/useAccessoriesEditor";
import AccessoriesSelectedPanel from "./AccessoriesSelectedPanel";
import AccessoriesAvailablePanel from "./AccessoriesAvailablePanel";
import "../../../../../assets/styles/BookingForm/accessories.css";

export default function AccessoriesDrawer({
    show,
    onClose,
    onSave,
    values,
    availableExtras,
    currentAccessories,
    customerCurrencyCode,
    sizeOptions,
    toCents,
    fromCents,
}) {
    const editor = useAccessoriesEditor({
        show,
        values,
        availableExtras,
        currentAccessories,
        customerCurrencyCode,
    });

    const handleSave = () => {
        const accessoriesToSave = (editor.leftAccessories || []).map((acc) => ({
            name: acc.extraName,
            shopMotorcycleExtraId: acc.shopMotorcycleExtraId, // personalized = null
            quantity: acc.qty ?? 1,
            priceCents: Number(acc.priceCents || 0),
            description: acc.info,
            // meta: { size: acc.size } // 如果后端支持可打开
        }));

        onSave(accessoriesToSave);
        onClose();
    };

    return (
        <Offcanvas
            show={show}
            onHide={onClose}
            placement="end"
            scroll
            backdrop
            className="acc acc-drawer"
        >
            <Offcanvas.Header closeButton className="drawer__header">
                <Offcanvas.Title>
                    <i className="bi bi-tools me-2"></i>
                    Motorcycle Accessories Editor
                </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="p-3">
                <Row className="g-3">
                    {/* Selected */}
                    <Col xs={12} lg={6} className="acc-split-divider pe-lg-3">
                        <AccessoriesSelectedPanel
                            customerCurrencyCode={customerCurrencyCode}
                            leftAccessories={editor.leftAccessories}
                            addPersonalized={editor.addPersonalized}
                            removePersonalized={editor.removePersonalized}
                            updateLeftField={editor.updateLeftField}
                            sizeOptions={sizeOptions}
                            toCents={toCents}
                            fromCents={fromCents}
                        />
                    </Col>

                    {/* Available */}
                    <Col xs={12} lg={6} className="ps-lg-3">
                        <AccessoriesAvailablePanel
                            customerCurrencyCode={customerCurrencyCode}
                            rightAccessories={editor.rightAccessories ?? []}
                            search={editor.search}
                            setSearch={editor.setSearch}
                            toggleRight={editor.toggleRight}
                        />
                    </Col>
                </Row>
            </Offcanvas.Body>

            <div className="acc-footer">
                <Button variant="outline-secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    <i className="bi bi-check-circle me-1"></i>
                    Save
                </Button>
            </div>
        </Offcanvas>
    );
}